export const isCurrentWarehouse = (
  warehouse: string | undefined,
  currentWarehouse: string | undefined
): boolean =>
  (warehouse || '').toUpperCase() === (currentWarehouse || '').toUpperCase();

export const getWarehouses = () => ['MEL', 'SYD'];
